/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import parse from "html-react-parser";

import '../../css/event220916_2.css';
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import { isMobile } from "react-device-detect";
//import $ from 'jquery';
// import ReactPlayer from "react-player";
// import Slider from "react-slick";

// import Timer from "react-timer-wrapper";
// import Timecode from "react-timecode";

// import ItemBox from "../../components/aketo/ItemBox";

// import { now } from "lodash";

class Event2022_agf extends Component {
  state = {
    tabIndex: 0,
  };

  componentDidMount = () => {};
  changeTab = (tab) => {
    //if(tab === 0) {
    this.setState({
      tabIndex: tab,
    });
    //} else {
    //alert('준비중입니다.')
    // }
  };
  render() {
    const { tabIndex } = this.state;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="event_head">
          <h3>AGF2022</h3>
          <button type="button" className="btnClose">
            <img src={imgUrl + '/img/detail_img/close_1.png'} alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event220916_2" style={{ color: '#fff' }}>
            <img src={imgUrl + '/img/event/event2022_agf/TOP.png'} />
          </div>
          <div>
            <span
              onClick={() => this.changeTab(0)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 0
                    ? imgUrl + '/img/event/event2022_agf/btn/01_MD.png'
                    : imgUrl + '/img/event/event2022_agf/btn/01_MD_off.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span>
            <span
              onClick={() => this.changeTab(1)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 1
                    ? imgUrl + '/img/event/event2022_agf/btn/02_CAFE.png'
                    : imgUrl + '/img/event/event2022_agf/btn/02_CAFE_OFF.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span>
            <span
              onClick={() => this.changeTab(2)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  tabIndex === 2
                    ? imgUrl + '/img/event/event2022_agf/btn/03_FAN_MEET.png'
                    : imgUrl +
                      '/img/event/event2022_agf/btn/03_FAN_MEET_OFF.png'
                }
                style={{ width: '33.33%', padding: 0, margin: 0 }}
              />
            </span>
          </div>

          {tabIndex === 0 ? (
            <Fragment>
              <div name="00_MD">
                <img
                  src={imgUrl + '/img/event/event2022_agf/00_MD.png'}
                  useMap="#FPMap0"
                />
              </div>
              <div>
                <a name="01_MD"></a>
                <img src={imgUrl + '/img/event/event2022_agf/01_holo_MD.png'} />
              </div>
              <div>
                <a name="02_MD"></a>
                <img src={imgUrl + '/img/event/event2022_agf/02_bang_MD.png'} />
              </div>
              <div>
                <a name="03_MD"></a>
                <img
                  src={imgUrl + '/img/event/event2022_agf/03_doriban_MD.png'}
                />
              </div>
              <div>
                <a name="04_MD"></a>
                <img src={imgUrl + '/img/event/event2022_agf/04_uma_MD.png'} />
              </div>
              <div>
                <a name="05_MD"></a>
                <img src={imgUrl + '/img/event/event2022_agf/05_spin_MD.png'} />
              </div>
              <div>
                <a name="06_MD"></a>
                <img src={imgUrl + '/img/event/event2022_agf/06_niz_MD.png'} />
              </div>
              <div>
                <a name="07_MD"></a>
                <img src={imgUrl + '/img/event/event2022_agf/07_spy_MD.png'} />
              </div>
              <map name="FPMap0">
                <area href="#01_MD" shape="rect" coords="120, 234, 601, 435" />
                <area href="#02_MD" shape="rect" coords="608, 238, 1088, 435" />
                <area
                  href="#03_MD"
                  shape="rect"
                  coords="1096, 234, 1576, 432"
                />
                <area href="#04_MD" shape="rect" coords="121, 440, 482, 638" />
                <area href="#05_MD" shape="rect" coords="489, 440, 848, 636" />
                <area href="#06_MD" shape="rect" coords="857, 439, 1212, 637" />
                <area
                  href="#07_MD"
                  shape="rect"
                  coords="1223, 441, 1577, 638"
                />
              </map>
            </Fragment>
          ) : tabIndex === 1 ? (
            <Fragment>
              <div name="00_CAFE">
                <img
                  src={imgUrl + '/img/event/event2022_agf/00_CAFE.png'}
                  useMap="#FPMap1"
                />
              </div>
              <div>
                <a name="01_CAFE"></a>
                <img
                  src={imgUrl + '/img/event/event2022_agf/01_holo_CAFE.png'}
                />
              </div>
              <div>
                <a name="02_CAFE"></a>
                <img
                  src={imgUrl + '/img/event/event2022_agf/02_bang_CAFE.png'}
                />
              </div>
              <div>
                <a name="03_CAFE"></a>
                <img
                  src={imgUrl + '/img/event/event2022_agf/03_niz_CAFE.png'}
                />
              </div>
              <div>
                <a name="04_CAFE"></a>
                <img
                  src={imgUrl + '/img/event/event2022_agf/04_ang_CAFE.png'}
                />
              </div>

              <map name="FPMap1">
                <area
                  href="#01_CAFE"
                  shape="rect"
                  coords="123, 236, 840, 434"
                />
                <area
                  href="#02_CAFE"
                  shape="rect"
                  coords="854, 235, 1578, 433"
                />
                <area
                  href="#03_CAFE"
                  shape="rect"
                  coords="120, 440, 842, 636"
                />
                <area
                  href="#04_CAFE"
                  shape="rect"
                  coords="853, 441, 1577, 640"
                />
              </map>
            </Fragment>
          ) : (
            <Fragment>
              <div name="00_FAN_MEET">
                <img
                  src={imgUrl + '/img/event/event2022_agf/00_FAN_MEET.png'}
                  useMap="#FPMap2"
                />
              </div>
              <div>
                <a name="01_FAN_MEET"></a>
                <img
                  src={imgUrl + '/img/event/event2022_agf/01_bang_FAN_MEET.png'}
                />
              </div>
              <div>
                <a name="02_FAN_MEET"></a>
                <img
                  src={imgUrl + '/img/event/event2022_agf/02_spy_FAN_MEET.png'}
                />
              </div>
              <div>
                <a name="03_FAN_MEET"></a>
                <img
                  src={imgUrl + '/img/event/event2022_agf/03_niz_FAN_MEET.png'}
                />
              </div>
              <map name="FPMap2">
                <area
                  href="#01_FAN_MEET"
                  shape="rect"
                  coords="122, 235, 596, 583"
                />
                <area
                  href="#02_FAN_MEET"
                  shape="rect"
                  coords="611, 235, 1085, 584"
                />
                <area
                  href="#03_FAN_MEET"
                  shape="rect"
                  coords="1100, 235, 1578, 585"
                />
              </map>
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event2022_agf));
